export default __webpack_public_path__ + "static/media/icon-search.6eb3272f.svg";